module.exports = __webpack_public_path__ + "img/status_0.bed124d0.png";